import { Button } from '@payaca/ambrosia';
import { clstx } from '@payaca/utilities/cvaMerge';
import { FC, useState } from 'react';
import ShadowDomRenderer from './ShadowDomRenderer';

export interface IProps {
  html: string;
}

const TruncatedShadowDomRenderer: FC<IProps> = (props) => {
  const { html } = props;
  const [isShowingMore, setIsShowingMore] = useState(false);

  return (
    <>
      <div
        className={clstx(
          isShowingMore
            ? ''
            : 'container-bottom-shadow relative max-h-52 overflow-hidden'
        )}
      >
        <ShadowDomRenderer html={html} />
      </div>
      <div>
        <Button variant="link" onClick={() => setIsShowingMore((s) => !s)}>
          {isShowingMore ? 'Show less' : 'Show more'}
        </Button>
      </div>
    </>
  );
};

export default TruncatedShadowDomRenderer;
